import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ReactComponent as BreadcrumbArrowGrayIcon } from "../../resources/icons/breadcrumbArrowGray.svg";
import { ReactComponent as BreadcrumbArrowBlackIcon } from "../../resources/icons/breadcrumbArrowBlack.svg";
import { useHistoryStore } from "../../store/HistoryProvider";
import { GET } from "../../service/CRUDService";
import EntityConstants from "../../configs/EntityConstants";
import { useTranslation } from "react-i18next";

const VpQrCode = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [qrCode, setQrCode] = useState();
  const [responseURI, setResponseURI] = useState();
  const { category_name, check_id } = useParams();
  const { historyStack, getHistoryEntry } = useHistoryStore();

  const getVpQrCode = async (id) => {
    try {
      const response = await GET(`${EntityConstants.GET_VP_QR_CODE}${id}`);
      const data = await response.json();
      setQrCode(data?.base64qrcode);
      setResponseURI(data?.response_uri);
    } catch (error) {
      console.log("error while getting category_name list: ", error);
    }
  };

  const pollResponseURI = async (url) => {
    const fetchData = async () => {
      if (window.location.pathname.startsWith("/verifier/vp/qrcode/")) {
        try {
          const response = await fetch(`${url}`);
          const data = await response.json();
          if (!data.vp_instance_id) {
            setTimeout(fetchData, 5000);
          } else {
            navigate(`/verifier/vp/result/${data.vp_instance_id}`);
          }
        } catch (error) {
          console.error("Polling error:", error);
          setTimeout(fetchData, 5000);
        }
      } else {
        return;
      }
    };

    fetchData();
  };

  const handleCheckNav = () => {
    const { path, title } = getHistoryEntry(
      -1,
      "/verifier/vp/check/",
      "partial"
    );
    path && navigate(path);
  };
  useEffect(() => {
    responseURI && pollResponseURI(responseURI);
  }, [responseURI]);
  useEffect(() => {
    check_id && getVpQrCode(check_id);
  }, [check_id]);

  return (
    <div className="flex flex-col items-center w-full pb-3 pt-20 bg-cfSecondary min-h-screen overflow-x-hidden">
      <div
        className="bg-[#F9FAFB] h-16 w-full flex gap-2 items-center px-8"
        id="vp-category"
      >
        {/* <HomeIcon className="w-6 h-6 mb-1" onClick={() => navigate("/")} />
        <BreadcrumbArrowGrayIcon className="w-6 h-6" /> */}
        <p
          id="vp-check-category-breadcrumb-button"
          className="font-semibold text-[#6C788F]  cursor-pointer"
          onClick={() => navigate("/verifier/vp/category")}
        >
          {t("request:select_category")}
        </p>
        <BreadcrumbArrowGrayIcon className="w-6 h-6" />
        <p
          id="vp-check-type-breadcrumb-button"
          className="font-semibold text-[#6C788F] cursor-pointer"
          onClick={() => handleCheckNav()}
        >
          {t("request:select_check_type")}
        </p>
        <BreadcrumbArrowBlackIcon className="w-6 h-6" />
        <p className="font-semibold text-cfTextBreadcrumbActive">
          {t("request:scan_qr_code")}
        </p>
      </div>
      <div className="w-full my-20 sm:m-8 flex flex-col items-center sm:items-start px-8">
        <p className="text-xl font-semibold">
          {t("request:scan_qr_code_period")}
        </p>
      </div>
      <div className="max-w-md w-full mx-auto bg-white rounded-3xl shadow-lg p-8">
        {/* <div className="max-w-md w-full mx-auto bg-white rounded-3xl shadow-lg p-8"> */}
        <h1 className="text-2xl font-semibold text-center mb-2 capitalize">
          {category_name}
        </h1>
        <p className="text-gray-500 text-center mb-3">
          {t("request:scan_qr_verify_instruction")}
        </p>
        {qrCode && (
          <div className="flex flex-col items-center">
            <div className="w-64 h-64 relative mb-4">
              <img
                src={qrCode || "/placeholder.svg"}
                alt="QR Code"
                className="w-full h-full object-contain rounded-lg border p-2"
              />
            </div>
          </div>
        )}
        {/* </div> */}
      </div>
    </div>
  );
};

export default VpQrCode;
